import React, { Component } from 'react';
import { connect } from 'react-redux';
import ResizeSensor from 'css-element-queries/src/ResizeSensor';
import { compose } from 'redux';

import Routes from './Routes';
import Footer from './Footer';
import {
	fetchInitData,
	fetchReservationData,
} from '../store/actions';
import { postMessageToParent } from '../utils';
import Error from './Error';
import LanguageSetter from "./LanguageSetter";

// Kroky formuláře pro crawler Googlu, viz https://developers.google.com/hotels/hotel-prices/structured-data/generic-crawler-guide
const NAV_STAGES = {
	1: 'landing',
	2: 'room-selection',
	3: 'packages',
	4: 'guest-details',
	5: 'checkout',
};

class App extends Component {

	constructor(props) {
		super(props);

		this.state = {
			didErrorOccurred: false,
			recaptcha: null,
			recaptchaToken: '',
			stylesInjected: false,
			langLoaded: false,
			resizeSensorInitialized: false,
		};
	}

	async componentDidMount() {
		try {
			await this.props.dispatch(fetchInitData());
			this.setState({stylesInjected: true});

		} catch (e) {
			console.error("Nepodařilo se načíst inicializační data.", e);
			this.setState({didErrorOccurred: true});
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.stylesInjected && this.state.langLoaded && (!prevState.stylesInjected || !prevState.langLoaded)) {
			this.props.dispatch(fetchReservationData());
		}
	}

	componentDidCatch(error, info) {
		this.setState({ didErrorOccurred: true });
	}

	setLangLoaded = () => {
		this.setState({ langLoaded: true });
	};

	setRecaptcha = (recaptcha) => {
		this.setState({ recaptcha });
	};

	recaptchaDidResolve = (recaptchaToken) => {
		this.setState({ recaptchaToken });
	};

	initResizeSensor = (el) => {
		if (el && !this.state.resizeSensorInitialized) {
			this.setState({ resizeSensorInitialized: true });
			this.appContainerEl = el;
			new ResizeSensor(el, this.onResize);
		}
	};

	onResize = () => {
		if (this.appContainerEl) {
			postMessageToParent('resize', this.appContainerEl.scrollHeight);
		}
	};

	render() {
		if (this.state.didErrorOccurred) return <Error />;

		const { step, source, hotel, hotelId, googleSoldOut } = this.props;
		const hotelName = hotel ? hotel.name : '';

		// Poslední stránka před osobními údaji, crawler Googlu je vyplnit neumí. U vyprodaného pokoje rovnou landing.
		const isFinalStage = step === 2 || (step === 1 && googleSoldOut);

		return (
			<div>
				<LanguageSetter setLangLoaded={this.setLangLoaded} />
				{this.state.stylesInjected && this.state.langLoaded ?
				<div
					className={`app-container web-step-${step}`}
					ref={el => this.initResizeSensor(el)}
					data-nav-stage={NAV_STAGES[step]}
					data-nav-stage-final={isFinalStage ? 'true' : undefined}
					itemScope={isFinalStage}
					itemType={isFinalStage ? 'https://schema.org/Hotel https://schema.org/LodgingReservation' : undefined}
				>
					{isFinalStage && <meta itemProp="identifier" content={hotelId} />}

					{source === 'google'
						? <h1 className="hotel-name" itemProp={isFinalStage ? 'name' : undefined}>{hotelName}</h1>
						: isFinalStage && <meta itemProp="name" content={hotelName} />
					}

					{step === 1 && googleSoldOut &&
					<div itemProp="makesOffer" itemScope itemType="https://schema.org/Offer">
						<meta itemProp="availability" content="https://schema.org/SoldOut" />
					</div>
					}

					<Routes
						recaptcha={this.state.recaptcha}
						recaptchaToken={this.state.recaptchaToken}
					/>
					<Footer
						setRecaptcha={this.setRecaptcha}
						recaptchaDidResolve={this.recaptchaDidResolve}
					/>
				</div>
				:
				<div data-nav-loading-indicator="true" />
				}
			</div>
		);
	}
}

export default compose(
	connect(state => ({
		langLoaded: state.app.langLoaded,
		step: state.app.step,
		source: state.app.source,
		hotel: state.app.hotel,
		hotelId: state.app.hotelId,
		googleSoldOut: state.app.googleSoldOut,
	})),
)(App);



// WEBPACK FOOTER //
// ./src/components/App.jsx